import { httpService } from '~/Services/Service';

// W-0595 — GES > Relatórios > Negócios > Lista de Negócios (read-only).
// Backend: RelNegociosController (RoutePrefix "rel-negocios"). Contrato snake_case.
// Lookups GET retornam RelNegocioOpcaoItem[] => { codigo, descricao }.
// /gerar (POST) é paginado => GerarRelNegociosResponse { itens, total_registros, pagina, tamanho_pagina }.
// /exportar-* (POST) devolvem binário (blob) — pattern fetch+responseType (LICOES Ciclo 10 L2).

const listarGruposEmpresa = () =>
  httpService.get('/rel-negocios/grupos-empresa');

const listarContas = codigoGrupoEmpresa =>
  httpService.get('/rel-negocios/contas', {
    // GET [FromUri] do WebAPI vincula por nome camelCase da action (codigoGrupoEmpresa);
    // o formatter snake_case só vale p/ body de POST. snake_case aqui = param não-vinculado = 404.
    params: { codigoGrupoEmpresa },
  });

const listarAtivos = () => httpService.get('/rel-negocios/ativos');

const listarUsuarios = () => httpService.get('/rel-negocios/usuarios');

const gerar = (payload = {}) =>
  httpService.post('/rel-negocios/gerar', payload);

const exportarPdf = (payload = {}) =>
  httpService.fetch({
    url: '/rel-negocios/exportar-pdf',
    method: 'post',
    data: payload,
    responseType: 'blob',
  });

const exportarExcel = (payload = {}) =>
  httpService.fetch({
    url: '/rel-negocios/exportar-excel',
    method: 'post',
    data: payload,
    responseType: 'blob',
  });

export default {
  listarGruposEmpresa,
  listarContas,
  listarAtivos,
  listarUsuarios,
  gerar,
  exportarPdf,
  exportarExcel,
};
